import React from "react";
import styles from "./headerLayout.module.css";
import unileverIcon from "../../../assets/images/unileverIcon.svg";
import Header from "./header";
import SamarthRouterHandler from "Samarth Module/routers/router";
import SidePanel from "../sidePanel/sidePanel";
import { useNavigate } from "react-router-dom";

const HeaderLayout = () => {
	const navigate = useNavigate();
	
	return (
		<div className={styles.container}>
			<header className={styles.header}>
				<Header />
			</header>
			<aside className={styles.aside}>
				<div className={styles.logoBox}>
					<img
						src={unileverIcon}
						alt="Unilever"
						className={styles.logo}
						onClick={() => navigate("/")}
					/>
				</div>
				<div className={styles.sidebarContainer}>
					<SidePanel />
				</div>
			</aside>
			<main className={styles.main}>
				<SamarthRouterHandler />
			</main>
		</div>
	);
};

export default HeaderLayout;
